export default __webpack_public_path__ + "static/media/spin-bg-23.658540c0.png";